<template>
  <el-dialog :title="formTitleMap[addressForm.action]" :visible.sync="dialogVisible" :close-on-click-modal="false" width="40%" v-loading="loading">
    <el-form ref="addressForm" :rules="addressRules" :model="addressForm" label-width="90px" size="small" class="address-form">
      <el-row>
        <el-col :span="12">
          <el-form-item label="联系人" prop="contactPerson">
            <el-input v-model="addressForm.contactPerson"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系手机" prop="contactMobile">
            <el-input v-model="addressForm.contactMobile" maxlength="11" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="地区" prop="areaData">
            <el-cascader v-model="addressForm.areaData" :options="areaOptions" :props="{ expandTrigger: 'hover' }" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系电话" prop="contactPhone">
            <el-input v-model="addressForm.contactPhone"/>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="详细地址" prop="detailAddress">
            <el-input v-model="addressForm.detailAddress"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="默认地址" prop="isDefault">
            <el-checkbox v-model="addressForm.isDefault" :true-label="1" :false-label="0" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button class="btn-orange-plain" @click="saveAddress">确 定</el-button>
      <el-button class="btn-grey" @click="dialogVisible = false">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
import formValidators from '@/utils/formValidators'
import userApi from '@/api/user'
export default {
  name: 'address-form',
  data () {
    const validateArea = (rule, value, callback) => {
      if (!value || value.length !== 3 || !value[0] || !value[1] || !value[2]) {
        callback(new Error('请选择地区信息'))
      } else {
        callback()
      }
    }
    return {
      addressForm: {
        action: '',
        contactPerson: '',
        contactMobile: '',
        contactPhone: '',
        provinceId: '',
        cityId: '',
        countyId: '',
        detailAddress: '',
        isDefault: 0,
        areaData: []
      },
      addressRules: {
        // shortAddress: [{ required: true, message: '请输入收货地址名称', trigger: 'change' }],
        contactPerson: [{ required: true, message: '请输入联系人', trigger: 'change' }],
        contactMobile: [
          { required: true, message: '请输入联系手机', trigger: 'change' },
          { validator: formValidators.checkMobile, trigger: 'change' }
        ],
        areaData: [
          { required: true, message: '请选择地区信息', trigger: 'change' },
          { validator: validateArea, trigger: 'change' }
        ],
        detailAddress: [{ required: true, message: '请输入详细地址', trigger: 'change' }]
      },
      dialogVisible: false,
      formTitleMap: {
        update: '修改地址',
        create: '新建地址'
      },
      loading: false
    }
  },
  computed: {
    ...mapState({
      areaOptions: state => state.base.areaData
    })
  },
  created () {
    this.$store.dispatch('getAreaData')
  },
  methods: {
    show (obj, option) {
      this.resetForm()
      if (obj) {
        this.addressForm = Object.assign(this.addressForm, obj)
      }
      this.addressForm.areaData.push(this.addressForm.provinceId)
      this.addressForm.areaData.push(this.addressForm.cityId)
      this.addressForm.areaData.push(this.addressForm.countyId)

      this.option = obj.option || null
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.addressForm.clearValidate()
      })
    },
    resetForm () {
      this.addressForm = {
        action: '',
        contactPerson: '',
        contactMobile: '',
        contactPhone: '',
        provinceId: '',
        cityId: '',
        countyId: '',
        detailAddress: '',
        isDefault: 0,
        areaData: []
      }
    },
    saveAddress () {
      this.$refs.addressForm.validate((valid) => {
        if (valid) {
          this.addressForm.provinceId = this.addressForm.areaData[0]
          this.addressForm.cityId = this.addressForm.areaData[1]
          this.addressForm.countyId = this.addressForm.areaData[2]
          if (this.addressForm.action === 'create') {
            this.submitCreate()
          }
          if (this.addressForm.action === 'update') {
            this.submitUpdate()
          }
        }
      })
    },
    submitCreate () {
      this.loading = true
      userApi.addAddress(this.addressForm).then(response => {
        this.loading = false
        if (response.data.resultCode === '0') {
          this.$emit('success')
          this.dialogVisible = false
          this.$message.success('收货地址创建成功')
        }
      }).catch(() => {
        this.loading = false
      })
    },
    submitUpdate () {
      this.loading = true
      userApi.updateAddress(this.addressForm).then(response => {
        this.loading = false
        if (response.data.resultCode === '0') {
          this.$emit('success')
          this.dialogVisible = false
          this.$message.success('收货地址更新成功')
        }
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style>

</style>
